/**
 * Error-drawer facts. Not a personality string.
 *
 * Interview system string is backend `LARK_ERROR_QA_PROMPT`.
 * This file only restates the thrown error. Do not paraphrase
 * `LARK_PERSONALITY`. Do not add cautious / suspicious / warm /
 * helpful. Never KAI. Tesla is out.
 */

import { LARK_ERROR_QUESTIONS } from '@/lib/lark-error-types';

export function buildErrorFactsTurn(input: {
  toastTitle: string;
  toastBody: string;
  route: string;
  systemErrorId: string;
}): string {
  const title = input.toastTitle.trim() || 'Error';
  const body = input.toastBody.trim();
  return [body ? `${title}. ${body}` : `${title}.`, input.route, `Error ${input.systemErrorId}.`, '', ...LARK_ERROR_QUESTIONS].join(
    '\n',
  );
}
